const s = (o) => !!(o && typeof o == "object" && "title" in o), c = (o) => {
  if (o && typeof o == "object") {
    const t = "success" in o && s(o.success), r = "error" in o && s(o.error);
    return t || r;
  }
  return !1;
};
export {
  c as isNotificationMeta,
  s as isNotificationParams
};
